import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import AccountDetails from 'components/user/AccountDetails';
import AccountUsers from 'components/user/AccountUsers';
import { changeMainView, changeHeaderTitle } from 'redux/appState';

const Account = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	useEffect(() => {
		dispatch(changeHeaderTitle(t('main.accountDetails')));
		dispatch(changeMainView(''));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<AccountDetails />
			</Grid>
			<Grid item xs={12}>
				<AccountUsers />
			</Grid>
		</Grid>
	)
}

export default Account;